import { render, staticRenderFns } from "./ExamFinishComponent.vue?vue&type=template&id=bc2503e4&scoped=true&"
import script from "./ExamFinishComponent.vue?vue&type=script&lang=js&"
export * from "./ExamFinishComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExamFinishComponent.vue?vue&type=style&index=0&id=bc2503e4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2503e4",
  null
  
)

export default component.exports